import { CardActions, CardContent, CardHeader } from "@material-ui/core";
import { FormInput, TextField } from "react-admin";
import React, { Fragment } from "react";

import ExecuteButton from "./buttons/ExecuteButton";
import { compose } from "recompose";
import withCardStyles from "../components/list/withCardStyles";

const Card = ({ classes, ...props }) => (
  <Fragment>
    <CardHeader
      className={classes.header}
      title={<TextField {...props} source="id" />}
    />
    <CardContent className={classes.content}>
      <FormInput {...props} source="id" input={<TextField addLabel />} />
      <FormInput {...props} source="name" input={<TextField addLabel />} />
    </CardContent>
    <CardActions className={classes.actions}>
      <ExecuteButton {...props} />
    </CardActions>
  </Fragment>
);
export default compose(withCardStyles)(Card);
